import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../reducers/languageSlice';
import { getLanguage } from '../utils/languageStorage';

/**
 * 다른 탭/도메인에서 언어 변경 시, 탭 전환하면 쿠키를 재확인해 Redux 동기화
 */
export default function LanguageSync() {
  const dispatch = useDispatch();
  const currentLang = useSelector(state => state.language?.language);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const newLang = getLanguage();
        if (newLang !== currentLang) {
          dispatch(setLanguage(newLang));
        }
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [dispatch, currentLang]);

  return null;
}
